export default {"src":"/_next/static/media/Spinner-Logo.1e17ddd9.gif","height":100,"width":100};